module.exports = __webpack_public_path__ + "static/media/ellipsis.7a7f40c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/GridPanelCard/ellipsis.svg
// module id = 1235
// module chunks = 0